import { render, staticRenderFns } from "./ComplianceReports.vue?vue&type=template&id=a674575a&scoped=true&"
import script from "./ComplianceReports.vue?vue&type=script&lang=js&"
export * from "./ComplianceReports.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceReports.vue?vue&type=style&index=0&id=a674575a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a674575a",
  null
  
)

export default component.exports